import { Controller } from '@hotwired/stimulus'

export class FeedbackFormController extends Controller {
  static targets = ['rating', 'submitButton']

  validate = (event) => {
    event.preventDefault()

    const valid = this.ratingTargets.reduce((acc, ratingContainer) => {
      const checkedRatingContainer = ratingContainer.querySelector('input[type=radio]:checked')
      const rating = checkedRatingContainer ? checkedRatingContainer.value : -1
      const lowestAllowedRating = ratingContainer.dataset.lowestAllowedRating || 0

      return acc && rating > lowestAllowedRating
    }, true)

    this.submitButtonTarget.disabled = !valid
  }
}
